import React from 'react'
import styled from 'styled-components';

function ContactItem({ icon, title, contact1, contact2 }) {
    return (
        <ContactItemStyled>
            <div className="left-content">
                <p className='icon'>
                    {icon}
                </p>
            </div>
            <div className="right-content">
                <h6>{title}</h6>
                <p>{contact1}</p>
                <p>{contact2}</p>
            </div>
        </ContactItemStyled>
    )
}

const ContactItemStyled = styled.div`  
    padding: 1.5rem 2rem;
    background-color: var(--background-dark-grey);
    display: flex;
    align-items: center;
    @media only screen and (max-width: 560px) {
        .icon{
            font-size: 2rem;
        }
        p, h6 {
            font-size: 60%;
        }
    }
    @media only screen and (max-width: 450px) {
        .icon{
            font-size: 1.5rem;
            margin-left: -1.2rem;
        }
        p, h6 {
            font-size: 50%;
            margin-left: -1.2rem;
        }
    }
    &:not(:last-child) {
        margin-bottom: 2rem;
    }
    .left-content {
        padding: 1.5rem;
        border: 1px solid var(--bordar-color);
        font-size: 2rem;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 1.5rem;
        svg{
            font-size: 2.3rem;
        }
    }
    .right-content {
        h6 {
            color: var(--white-color);
            font-size: 1.2rem;
            padding-bottom: .6rem;
        }
        p {
            padding: .1rem 0;
        }
    }
`;

export default ContactItem;
